import React from "react";
import styles from "./Header.module.css";
import { LanguageToggleButton } from "../LanguageToggleButton";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { t } = useTranslation();
  return (
    <header className={styles.siteHeader}>
      <div className={styles.container}>
        <div className={styles.siteHeaderInner}>
          <div className={styles.brand}>
            <h1 className={styles.m0}>
              <a href="#" className="block">
                <span className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 dark:text-white whitespace-nowrap">
                 {t("title")}
                </span>
              </a>
            </h1>
          </div>
           <LanguageToggleButton />
        </div>
      </div>
    </header>
  );
};

export default Header;
